export default "__VITE_ASSET__K_mXyWQR__"